const urlBase = `${process.env.REACT_APP_API_PROTOCOL}://${
  process.env.REACT_APP_API_HOST
}${
  process.env.REACT_APP_API_PORT ? `:${process.env.REACT_APP_API_PORT}` : ""
}/api/`;

/** AUTH **/
export const urlGetLoginItemTemp = `${urlBase}v1/items/login`;

export const urlRefreshToken = `${urlBase}v1/user/refresh-token`;
export const urlLogout = `${urlBase}v1/user/logout`;
export const urlGetProfile = `${urlBase}v1/user-s/profile`;

export const urlPreRegisterEmployee = `${urlBase}v1/employeeRequest-s/preRegister`;
export const urlEvaluationSecured = `${urlBase}v1/evaluation-s`;
export const urlDataToEvaluationSecured = `${urlBase}v1/evaluation-s/loadForm`;
export const urlEvaluationConfirmSecured = `${urlBase}v1/evaluation-s/confirm`;
export const urlToEvaluationSecured = `${urlBase}v1/toEval-s`;
export const urlToEvaluationConsultSecured = `${urlBase}v1/toEval-s/consult`;
export const urlToEvaluationExportSecured = `${urlBase}v1/toEval-s/export`;

export const urlDataUser = `${urlBase}v1/dataUser-s`;
export const urlConfigSecured = `${urlBase}v1/config-s`;
export const urlConfigFinishSecured = `${urlBase}v1/config-s/finishStep`;
export const urlConfigReminderSecured = `${urlBase}v1/config-s/reminder`;
export const urlGetMyEvaluationSecured = `${urlBase}v1/evaluation-s/myEvaluation/active`;
export const urlConfirmAutoEvaluationSecured = `${urlBase}v1/evaluation-s/confirmAutoEvaluation`;
export const urlSetEvaluationSecured = `${urlBase}v1/evaluation-s/evaluation`;
export const urlDataUserFilterAll = `${urlBase}v1/dataUser-s/all`;
export const urlNotifiedEvaluationSecured = `${urlBase}v1/evaluation-s/notified`;
export const urlCalibrationEvaluationSecured = `${urlBase}v1/evaluation-s/calibration`;
export const urlSetAutoObjectUnitEvaluationSecured = `${urlBase}v1/evaluation-s/setAutoObjectUnitEvaluation`;
export const urlSetManagerObjectUnitEvaluationSecured = `${urlBase}v1/evaluation-s/setManagerObjectUnitEvaluation`;
export const urlConfirmManagerEvaluationSecured = `${urlBase}v1/evaluation-s/confirmManagerEvaluation`;
export const urlUserFilterAll = `${urlBase}v1/user-s/all`;


export const urlReportSecured = `${urlBase}v1/report-s`;
export const urlReportAllSecured = `${urlBase}v1/report-s/all`;
export const urlReportOneSecured = `${urlBase}v1/report-s/one`;

export const urlSkillsSecured = `${urlBase}v1/professionalSkill-s`;
